import type { ViewType } from 'owa-calendar-actions';
import type { CalendarEvent } from 'owa-calendar-types';
import { ControlIcons } from 'owa-control-icons';
import { getDeleteMenuItems, canShowDeleteButton } from 'owa-event-context-menu';
import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import loc from 'owa-localize';
import { delete_0 } from 'owa-locstrings/lib/strings/delete_0.locstring.json';
import type EventScope from 'owa-service/lib/contract/EventScope';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * Returns the button for delete
 * @param event Calendar event
 * @param actionSource Calendar view
 * @param isFullForm
 * @param onDeleteClicked delete callback
 */
export const getDeleteButton = (
    event: CalendarEvent,
    actionSource: ViewType,
    isFullForm: boolean,
    isInPopOutWindow: boolean,
    onDeleteClicked: (
        eventScope: EventScope,
        isInPopOutWindow: boolean,
        event?: CalendarEvent
    ) => void,
    onMenuOpened?: () => void
): FilterableMenuItem => {
    let onClick;
    let menuItems;

    const deleteMenuItems = getDeleteMenuItems(
        event,
        actionSource,
        (eventScope: EventScope, actionSource: ViewType) =>
            onDeleteClicked(eventScope, isInPopOutWindow, event)
    );

    if (deleteMenuItems.length == 1) {
        onClick = deleteMenuItems[0].onClick;
    } else {
        menuItems = deleteMenuItems;
    }

    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(delete_0),
        [FilterableMenuItemArgs.icon]: isFeatureEnabled('mon-cal-addDeleteOrCancelInEdit')
            ? ControlIcons.RemoveEvent
            : ControlIcons.Delete,
        [FilterableMenuItemArgs.onClick]: onClick,
        [FilterableMenuItemArgs.shouldShow]: () => canShowDeleteButton(event, isFullForm),
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.menuContent]: menuItems
            ? {
                  items: menuItems,
                  onMenuOpened: onMenuOpened,
              }
            : undefined,
        [FilterableMenuItemArgs.key]: 'Delete',
    });
};
